import { buildClassName, lookupPreset } from "./util";

// id: "c6924d21-99f9-4469-9b97-4d728dcf0ba0"
// title: "Home Page Hero"
// type: :html
// key: "home-page-hero"
// parent_id: nil
export function HomePageHeroC6924d2199f944699b974d728dcf0ba0(props: any) {
  const ContentSnippet = lookupPreset("ContentSnippet");
  const Button = lookupPreset("Button");
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} HomePageHeroC6924d2199f944699b974d728dcf0ba0 hero`}>
      <div className="title">
        {props["title"] || <ContentSnippet className="TitleBfafcb49C1814294967fDf3d333cd11f" parentTag={buildClassName("TitleBfafcb49C1814294967fDf3d333cd11f", parentTag)} contentSlug="home-hero-title" {...props} />}
      </div>
      <div className="button">
        {props["button"] || <Button className="Button2ff60546Dac4400fB0d23ed8907b53ce" parentTag={buildClassName("Button2ff60546Dac4400fB0d23ed8907b53ce", parentTag)} label="Join Us" href="/join" {...props} />}
      </div>
    </div>
  );
}

// id: "c36c6ef7-472f-4b08-bad4-d727591b5aed"
// title: "HREF"
// type: :text
// key: "href"
// parent_id: nil
export const HrefC36c6ef7472f4b08Bad4D727591b5aed = "/";

// id: "4d80fcc2-2046-4800-abaa-2a95523b9a78"
// title: "Short Header"
// type: :html
// key: "short-header"
// parent_id: nil
export function ShortHeader4d80fcc220464800Abaa2a95523b9a78(props: any) {
  const Link = lookupPreset("Link");
  const PrimaryNavigation = lookupPreset("PrimaryNavigation");
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} ShortHeader4d80fcc220464800Abaa2a95523b9a78 site-header`}>
      <div className="background-image" />
      <div className="header-top">
        {props["linked-logo"] || <Link className="LinkedLogo9df776a9Bbb648e496958ffbce9fb772" parentTag={buildClassName("LinkedLogo9df776a9Bbb648e496958ffbce9fb772", parentTag)} label={<DefaultLogoCe618a45066f4e8dB10c770a5f79bee6 parentTag="Label322e09c0A4484ef3892e2c514ee97cd7" alt="logo" />} {...props} />}
        {props["navigation"] || <PrimaryNavigation className="Navigation8efb69872b0a4201B420Bdeaf69b69a4" parentTag={buildClassName("Navigation8efb69872b0a4201B420Bdeaf69b69a4", parentTag)} navMenuSlug="members-primary-nav" {...props} />}
      </div>
    </div>
  );
}

// id: "a8e9dcdb-3bd0-4fd7-bcf5-ba7d56b37e0b"
// title: "Marketing Primary Navigation"
// type: :text
// key: "navMenuSlug"
// parent_id: "385427a1-bd50-46e5-8646-a1458cc31643"
export const NavMenuSlugA8e9dcdb3bd04fd7Bcf5Ba7d56b37e0b = "marketing-primary-nav";

// id: "df401107-78ea-4463-b619-63f921d2247f"
// title: ""
// type: :reference
// key: "header"
// parent_id: "47b6abe1-382f-4276-8143-37bdafa9443b"
export function HeaderDf40110778ea4463B61963f921d2247f(props: any) {
  return (
    <MembersAreaHeader745bba7772714418B348F47372dfa03d parentTag="HeaderDf40110778ea4463B61963f921d2247f" navMenuSlug="members-primary-nav" {...props} />
  );
}

// id: "e7b400a3-1988-4bad-b736-03bf353716f8"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "b74b7c7e-56d8-493e-a011-de5131c754cc"
export const ContentSlugE7b400a319884badB73603bf353716f8 = "home-page-quote";

// id: "a72cc2ed-1a20-4fdb-a2a0-21d40931618d"
// title: "Public Events Page"
// type: :html
// key: "public-events-page"
// parent_id: nil
export function PublicEventsPageA72cc2ed1a204fdbA2a021d40931618d(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} PublicEventsPageA72cc2ed1a204fdbA2a021d40931618d`}>
      {props["header"] || <SecondaryMarketingHeader7745eefb04164eb2B2a4134a9071d600 parentTag="Header4b39494bA7c745e2A0216ef8f393ecf5" title="Public Events" {...props} />}
      {props.children}
      {props["footer"] || <DefaultFooterCd2d001090fb43149ac6246cf52fa408 parentTag="FooterFe7212a6Bc854fda9c22F04bff95ae97" {...props} />}
    </div>
  );
}

// id: "3fa55dd0-01e8-4be3-83f6-c4a4676d3ab5"
// title: ""
// type: :reference
// key: "footer"
// parent_id: "467c8232-de2c-48f2-8006-0994f42f3c42"
export function Footer3fa55dd001e84be383f6C4a4676d3ab5(props: any) {
  return (
    <DefaultFooterCd2d001090fb43149ac6246cf52fa408 parentTag="Footer3fa55dd001e84be383f6C4a4676d3ab5" {...props} />
  );
}

// id: "ca3a7edd-3378-4785-a2c0-a4333dbfcd82"
// title: ""
// type: :text
// key: "title"
// parent_id: "7745eefb-0416-4eb2-b2a4-134a9071d600"
export const TitleCa3a7edd33784785A2c0A4333dbfcd82 = "Secondary Marketing Title 1";

// id: "cae9eee6-2a80-46c8-a2d3-c013315382be"
// title: ""
// type: :reference
// key: "footer"
// parent_id: "819d7eed-c2b5-45c7-8cb7-364f2526597a"
export function FooterCae9eee62a8046c8A2d3C013315382be(props: any) {
  return (
    <DefaultFooterCd2d001090fb43149ac6246cf52fa408 parentTag="FooterCae9eee62a8046c8A2d3C013315382be" {...props} />
  );
}

// id: "42bfab54-fbae-4f28-936a-a2619552c65c"
// title: ""
// type: :text
// key: "title"
// parent_id: "a1d697e5-4fb6-46cf-a5a1-96590abbc9d6"
export const Title42bfab54Fbae4f28936aA2619552c65c = "Secondary Marketing Title 2";

// id: "3098910b-4ed1-4707-b432-4d4ce5793157"
// title: "Members Header"
// type: :reference
// key: "header"
// parent_id: nil
export function Header3098910b4ed14707B4324d4ce5793157(props: any) {
  return (
    <MembersAreaHeader745bba7772714418B348F47372dfa03d parentTag="Header3098910b4ed14707B4324d4ce5793157" {...props} />
  );
}

// id: "fbdfe1ce-1900-4c9b-abd9-4aa28a28a4a1"
// title: ""
// type: :text
// key: "buttonClass"
// parent_id: "3d016643-a936-4700-ab2e-1fc4fe5705b6"
export const ButtonClassFbdfe1ce19004c9bAbd94aa28a28a4a1 = "inline-block px-12 py-3 hover:brightness-110 transition duration";

// id: "36165753-5306-4408-a37f-8c659011e366"
// title: ""
// type: :reference
// key: "header"
// parent_id: "a26e9b13-22ac-4469-b64f-252069808545"
export function Header3616575353064408A37f8c659011e366(props: any) {
  return (
    <SecondaryMarketingHeader7745eefb04164eb2B2a4134a9071d600 parentTag="Header3616575353064408A37f8c659011e366" title="Join Us" {...props} />
  );
}

// id: "db947236-8251-44a9-9c48-0ee4bc6bea1b"
// title: ""
// type: :text
// key: "backgroundImage"
// parent_id: "4d80fcc2-2046-4800-abaa-2a95523b9a78"
export const BackgroundImageDb947236825144a99c480ee4bc6bea1b = "https://mp1md-pub.s3.amazonaws.com/orgs/new-culture/alexander-grey-Jv_oD5CuVfw-unsplash%20orig.jpg";

// id: "6024bc3b-5cba-41fb-b25f-ebf7ed943299"
// title: ""
// type: :text
// key: "label"
// parent_id: "2ff60546-dac4-400f-b0d2-3ed8907b53ce"
export const Label6024bc3b5cba41fbB25fEbf7ed943299 = "Join Us";

// id: "47b6abe1-382f-4276-8143-37bdafa9443b"
// title: "Members Area"
// type: :html
// key: "members-area-default"
// parent_id: nil
export function MembersAreaDefault47b6abe1382f4276814337bdafa9443b(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} MembersAreaDefault47b6abe1382f4276814337bdafa9443b page`}>
      {props["header"] || <MembersAreaHeader745bba7772714418B348F47372dfa03d parentTag="HeaderDf40110778ea4463B61963f921d2247f" navMenuSlug="members-primary-nav" {...props} />}
      {props["footer"] || <DefaultFooterCd2d001090fb43149ac6246cf52fa408 parentTag="FooterA4492fa31b63476bA4d70b5cb0141636" {...props} />}
    </div>
  );
}

// id: "68f8eef4-35a5-4912-8d10-0258ae2dde19"
// title: "Signup Pages"
// type: :reference
// key: "signup-pages"
// parent_id: nil
export function SignupPages68f8eef435a549128d100258ae2dde19(props: any) {
  return (
    <SecondaryPage819d7eedC2b545c78cb7364f2526597a parentTag="SignupPages68f8eef435a549128d100258ae2dde19" header={<SecondaryMarketingHeader7745eefb04164eb2B2a4134a9071d600 parentTag="Header118372f185bf4089Bc76865e374ea742" title="Join Us" />} {...props} />
  );
}

// id: "360eed49-bef8-4a97-ab8f-5df36f0ba5ed"
// title: ""
// type: :gf_preset
// key: "welcome-back"
// parent_id: "da61957a-71ba-45ca-ac9b-42f666ed30f8"
export function WelcomeBack360eed49Bef84a97Ab8f5df36f0ba5ed(props: any) {
  const WelcomeBackPopUp = lookupPreset("WelcomeBackPopUp");
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <WelcomeBackPopUp className="WelcomeBack360eed49Bef84a97Ab8f5df36f0ba5ed" parentTag={buildClassName("WelcomeBack360eed49Bef84a97Ab8f5df36f0ba5ed", parentTag)} {...props} />
  );
}

// id: "97dbec69-5fbf-497d-84f4-db252658fa2e"
// title: ""
// type: :text
// key: "href"
// parent_id: "2ff60546-dac4-400f-b0d2-3ed8907b53ce"
export const Href97dbec695fbf497d84f4Db252658fa2e = "/join";

// id: "83051fa7-0733-4a72-a342-e31d759feccd"
// title: ""
// type: :text
// key: "postSlug"
// parent_id: "a369f75c-c0dc-4d78-9c74-0d98873a1156"
export const PostSlug83051fa707334a72A342E31d759feccd = "home-page-posts2";

// id: "c6395266-ab58-4052-948f-3e30603e1d38"
// title: "Header Area Top"
// type: :html
// key: "default-header-top"
// parent_id: nil
export function DefaultHeaderTopC6395266Ab584052948f3e30603e1d38(props: any) {
  const Link = lookupPreset("Link");
  const PrimaryNavigation = lookupPreset("PrimaryNavigation");
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} DefaultHeaderTopC6395266Ab584052948f3e30603e1d38 header-top`}>
      {props["linked-logo"] || <Link className="LinkedLogo5231ec57Fc5e4b9fBe6b7dc3d14ae51b" parentTag={buildClassName("LinkedLogo5231ec57Fc5e4b9fBe6b7dc3d14ae51b", parentTag)} url="/" label={<DefaultLogoCe618a45066f4e8dB10c770a5f79bee6 parentTag="Label329a825a905648308c75C79ab0de1fd2" alt="logo" />} className="linked-logo" {...props} />}
      {props["navigation"] || <PrimaryNavigation className="Navigation2ff3c744Bcb94d1081fc701ecd590232" parentTag={buildClassName("Navigation2ff3c744Bcb94d1081fc701ecd590232", parentTag)} className="navigation" navMenuSlug="marketing-primary-nav" {...props} />}
    </div>
  );
}

// id: "a26e9b13-22ac-4469-b64f-252069808545"
// title: "Join Us Page"
// type: :reference
// key: "join-us-page"
// parent_id: nil
export function JoinUsPageA26e9b1322ac4469B64f252069808545(props: any) {
  return (
    <SecondaryPage819d7eedC2b545c78cb7364f2526597a parentTag="JoinUsPageA26e9b1322ac4469B64f252069808545" header={<SecondaryMarketingHeader7745eefb04164eb2B2a4134a9071d600 parentTag="Header3616575353064408A37f8c659011e366" title="Join Us" />} {...props} />
  );
}

// id: "a8f063a9-1b1e-45ec-a1c6-045e2e985946"
// title: ""
// type: :reference
// key: "body"
// parent_id: "da61957a-71ba-45ca-ac9b-42f666ed30f8"
export function BodyA8f063a91b1e45ecA1c6045e2e985946(props: any) {
  return (
    <MarketingBodyAa2a9e0bAe764a6cAebb6b9c75fb86bf parentTag="BodyA8f063a91b1e45ecA1c6045e2e985946" {...props} />
  );
}

// id: "2ff3c744-bcb9-4d10-81fc-701ecd590232"
// title: ""
// type: :gf_preset
// key: "navigation"
// parent_id: "c6395266-ab58-4052-948f-3e30603e1d38"
export function Navigation2ff3c744Bcb94d1081fc701ecd590232(props: any) {
  const PrimaryNavigation = lookupPreset("PrimaryNavigation");
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <PrimaryNavigation className="Navigation2ff3c744Bcb94d1081fc701ecd590232" parentTag={buildClassName("Navigation2ff3c744Bcb94d1081fc701ecd590232", parentTag)} className="navigation" navMenuSlug="marketing-primary-nav" {...props} />
  );
}

// id: "26eaf94e-ff2e-4ed8-9ad1-34af04c54ed8"
// title: ""
// type: :text
// key: "url"
// parent_id: "5231ec57-fc5e-4b9f-be6b-7dc3d14ae51b"
export const Url26eaf94eFf2e4ed89ad134af04c54ed8 = "/";

// id: "62a5ea3b-a58d-477c-af1c-7f736286cc60"
// title: "Common Footer"
// type: :reference
// key: "footer"
// parent_id: nil
export function Footer62a5ea3bA58d477cAf1c7f736286cc60(props: any) {
  return (
    <DefaultFooterCd2d001090fb43149ac6246cf52fa408 parentTag="Footer62a5ea3bA58d477cAf1c7f736286cc60" {...props} />
  );
}

// id: "85fc56c8-5578-4a66-9865-e675e07d0430"
// title: "Page Quote"
// type: :html
// key: "page-quote"
// parent_id: nil
export function PageQuote85fc56c855784a669865E675e07d0430(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} PageQuote85fc56c855784a669865E675e07d0430`}>
      <div>
      </div>
      <div>
      </div>
    </div>
  );
}

// id: "bfafcb49-c181-4294-967f-df3d333cd11f"
// title: ""
// type: :gf_preset
// key: "title"
// parent_id: "c6924d21-99f9-4469-9b97-4d728dcf0ba0"
export function TitleBfafcb49C1814294967fDf3d333cd11f(props: any) {
  const ContentSnippet = lookupPreset("ContentSnippet");
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <ContentSnippet className="TitleBfafcb49C1814294967fDf3d333cd11f" parentTag={buildClassName("TitleBfafcb49C1814294967fDf3d333cd11f", parentTag)} contentSlug="home-hero-title" {...props} />
  );
}

// id: "a1d697e5-4fb6-46cf-a5a1-96590abbc9d6"
// title: ""
// type: :reference
// key: "hero"
// parent_id: "7745eefb-0416-4eb2-b2a4-134a9071d600"
export function HeroA1d697e54fb646cfA5a196590abbc9d6(props: any) {
  return (
    <SecondaryMarketingHero5f9c91cd93d045d9Ac59Ef8c7b564c33 parentTag="HeroA1d697e54fb646cfA5a196590abbc9d6" title="Secondary Marketing Title 2" {...props} />
  );
}

// id: "8ef9963a-e8c1-49a9-8efd-bc75d812a0a0"
// title: ""
// type: :text
// key: "title"
// parent_id: "e9cd2230-94d1-45b1-8da8-f3e74aa9add4"
export const Title8ef9963aE8c149a98efdBc75d812a0a0 = "Leveling";

// id: "0f8a2499-6f49-4a37-9381-b366f0ec53d2"
// title: ""
// type: :text
// key: "title"
// parent_id: "36165753-5306-4408-a37f-8c659011e366"
export const Title0f8a24996f494a379381B366f0ec53d2 = "Join Us";

// id: "7745eefb-0416-4eb2-b2a4-134a9071d600"
// title: "Secondary Marketing Header"
// type: :html
// key: "secondary-marketing-header"
// parent_id: nil
export function SecondaryMarketingHeader7745eefb04164eb2B2a4134a9071d600(props: any) {
  const { parentTag, ...rest } = props;
  props = { title: "Secondary Marketing Title 1", ...rest };
  return (
    <div className={`${parentTag || ""} SecondaryMarketingHeader7745eefb04164eb2B2a4134a9071d600 site-header`}>
      <div className="background-image" />
      <div className="header-top-wrapper">
        <div className="header-top-opacity">
        </div>
        {props["header-top"] || <DefaultHeaderTopC6395266Ab584052948f3e30603e1d38 parentTag="HeaderTop35989f4b7d8249e4B8f26be2a7ef729c" {...props} />}
      </div>
      {props["hero"] || <SecondaryMarketingHero5f9c91cd93d045d9Ac59Ef8c7b564c33 parentTag="HeroA1d697e54fb646cfA5a196590abbc9d6" title="Secondary Marketing Title 2" {...props} />}
    </div>
  );
}

// id: "819d7eed-c2b5-45c7-8cb7-364f2526597a"
// title: "Secondary Page"
// type: :html
// key: "secondary-page"
// parent_id: nil
export function SecondaryPage819d7eedC2b545c78cb7364f2526597a(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} SecondaryPage819d7eedC2b545c78cb7364f2526597a`}>
      {props["header"] || <SecondaryMarketingHeader7745eefb04164eb2B2a4134a9071d600 parentTag="HeaderD9297d3298954073Bf7e0ec7dcf5b078" title="Secondary Page" {...props} />}
      <div className="text-content">
        {props.children}
      </div>
    </div>
  );
}

// id: "b74b7c7e-56d8-493e-a011-de5131c754cc"
// title: ""
// type: :gf_preset
// key: "quote"
// parent_id: "da61957a-71ba-45ca-ac9b-42f666ed30f8"
export function QuoteB74b7c7e56d8493eA011De5131c754cc(props: any) {
  const PageQuote = lookupPreset("PageQuote");
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <PageQuote className="QuoteB74b7c7e56d8493eA011De5131c754cc" parentTag={buildClassName("QuoteB74b7c7e56d8493eA011De5131c754cc", parentTag)} contentSlug="home-page-quote" {...props} />
  );
}

// id: "d1c4cde0-82a2-402d-b139-6c865309f0a6"
// title: ""
// type: :reference
// key: "header"
// parent_id: "c040cadf-4bac-463e-904e-6456d750f401"
export function HeaderD1c4cde082a2402dB1396c865309f0a6(props: any) {
  return (
    <SecondaryMarketingHeader7745eefb04164eb2B2a4134a9071d600 parentTag="HeaderD1c4cde082a2402dB1396c865309f0a6" title="Resources" {...props} />
  );
}

// id: "b5e05987-143e-41b3-8b73-661726788c88"
// title: ""
// type: :text
// key: "contentSlug"
// parent_id: "bfafcb49-c181-4294-967f-df3d333cd11f"
export const ContentSlugB5e05987143e41b38b73661726788c88 = "home-hero-title";

// id: "da61957a-71ba-45ca-ac9b-42f666ed30f8"
// title: "Home Page"
// type: :html
// key: "home-page"
// parent_id: nil
export function HomePageDa61957a71ba45caAc9b42f666ed30f8(props: any) {
  const WelcomeBackPopUp = lookupPreset("WelcomeBackPopUp");
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} HomePageDa61957a71ba45caAc9b42f666ed30f8 page`}>
      {props["header"] || <HomeHeader65c78da3057a41a4Af115643aaedf7d1 parentTag="Header0be972ad05aa46fe9a73D836038e6b4f" {...props} />}
      {props["welcome-back"] || <WelcomeBackPopUp className="WelcomeBack360eed49Bef84a97Ab8f5df36f0ba5ed" parentTag={buildClassName("WelcomeBack360eed49Bef84a97Ab8f5df36f0ba5ed", parentTag)} {...props} />}
      {props["body"] || <MarketingBodyAa2a9e0bAe764a6cAebb6b9c75fb86bf parentTag="BodyA8f063a91b1e45ecA1c6045e2e985946" {...props} />}
      {props["footer"] || <DefaultFooterCd2d001090fb43149ac6246cf52fa408 parentTag="Footer5a695c01C2e3412e800e71c30f983479" {...props} />}
    </div>
  );
}

// id: "31886609-2f22-43fc-8c7b-0c05ebc0d508"
// title: "Member Pages"
// type: :html
// key: "member-pages"
// parent_id: nil
export function MemberPages318866092f2243fc8c7b0c05ebc0d508(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} MemberPages318866092f2243fc8c7b0c05ebc0d508`}>
      {props["header"] || <MembersAreaHeader745bba7772714418B348F47372dfa03d parentTag="HeaderBd34f78b8dcb4bd893ab61c7f195e37e" {...props} />}
      {props.children}
      {props["footer"] || <DefaultFooterCd2d001090fb43149ac6246cf52fa408 parentTag="Footer953b6bfbD57d458aB8e5735bc1c0a94b" {...props} />}
    </div>
  );
}

// id: "118372f1-85bf-4089-bc76-865e374ea742"
// title: ""
// type: :reference
// key: "header"
// parent_id: "68f8eef4-35a5-4912-8d10-0258ae2dde19"
export function Header118372f185bf4089Bc76865e374ea742(props: any) {
  return (
    <SecondaryMarketingHeader7745eefb04164eb2B2a4134a9071d600 parentTag="Header118372f185bf4089Bc76865e374ea742" title="Join Us" {...props} />
  );
}

// id: "7297aef3-09e1-43d4-9f29-09dc3bbe54fc"
// title: ""
// type: :reference
// key: "header"
// parent_id: "89794182-97d7-4e9c-90a4-07ff3f8e5610"
export function Header7297aef309e143d49f2909dc3bbe54fc(props: any) {
  return (
    <SecondaryMarketingHeader7745eefb04164eb2B2a4134a9071d600 parentTag="Header7297aef309e143d49f2909dc3bbe54fc" title="About Us" {...props} />
  );
}

// id: "2dced3b8-8cca-4145-b88f-692c6d08acf5"
// title: ""
// type: :text
// key: "title"
// parent_id: "118372f1-85bf-4089-bc76-865e374ea742"
export const Title2dced3b88cca4145B88f692c6d08acf5 = "Join Us";

// id: "89794182-97d7-4e9c-90a4-07ff3f8e5610"
// title: "About Us"
// type: :html
// key: "about-us-page"
// parent_id: nil
export function AboutUsPage8979418297d74e9c90a407ff3f8e5610(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} AboutUsPage8979418297d74e9c90a407ff3f8e5610 page`}>
      {props["header"] || <SecondaryMarketingHeader7745eefb04164eb2B2a4134a9071d600 parentTag="Header7297aef309e143d49f2909dc3bbe54fc" title="About Us" {...props} />}
      {props["body"] || <MarketingBodyAa2a9e0bAe764a6cAebb6b9c75fb86bf parentTag="Body7166221938a14bbcA547F6f772f02e29" postSlug="about-us-posts" {...props} />}
      {props["footer"] || <DefaultFooterCd2d001090fb43149ac6246cf52fa408 parentTag="Footer8a626229A8d944d5A969369688734755" {...props} />}
    </div>
  );
}

// id: "d9297d32-9895-4073-bf7e-0ec7dcf5b078"
// title: ""
// type: :reference
// key: "header"
// parent_id: "819d7eed-c2b5-45c7-8cb7-364f2526597a"
export function HeaderD9297d3298954073Bf7e0ec7dcf5b078(props: any) {
  return (
    <SecondaryMarketingHeader7745eefb04164eb2B2a4134a9071d600 parentTag="HeaderD9297d3298954073Bf7e0ec7dcf5b078" title="Secondary Page" {...props} />
  );
}

// id: "b8ecd9df-4b5f-4af4-927a-6076a5037683"
// title: ""
// type: :gf_preset
// key: "copyright"
// parent_id: "cd2d0010-90fb-4314-9ac6-246cf52fa408"
export function CopyrightB8ecd9df4b5f4af4927a6076a5037683(props: any) {
  const GroupCopyright = lookupPreset("GroupCopyright");
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <GroupCopyright className="CopyrightB8ecd9df4b5f4af4927a6076a5037683" parentTag={buildClassName("CopyrightB8ecd9df4b5f4af4927a6076a5037683", parentTag)} {...props} />
  );
}

// id: "8a626229-a8d9-44d5-a969-369688734755"
// title: ""
// type: :reference
// key: "footer"
// parent_id: "89794182-97d7-4e9c-90a4-07ff3f8e5610"
export function Footer8a626229A8d944d5A969369688734755(props: any) {
  return (
    <DefaultFooterCd2d001090fb43149ac6246cf52fa408 parentTag="Footer8a626229A8d944d5A969369688734755" {...props} />
  );
}

// id: "a87c79a2-7d74-4bc4-b9f6-75f3b462e519"
// title: ""
// type: :text
// key: "title"
// parent_id: "d1c4cde0-82a2-402d-b139-6c865309f0a6"
export const TitleA87c79a27d744bc4B9f675f3b462e519 = "Resources";

// id: "65c78da3-057a-41a4-af11-5643aaedf7d1"
// title: "Home Header"
// type: :html
// key: "home-header"
// parent_id: nil
export function HomeHeader65c78da3057a41a4Af115643aaedf7d1(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} HomeHeader65c78da3057a41a4Af115643aaedf7d1 site-header`}>
      <div className="background-image" />
      <div className="header-top-wrapper">
        <div className="header-top-opacity">
        </div>
        {props["header-top"] || <DefaultHeaderTopC6395266Ab584052948f3e30603e1d38 parentTag="HeaderTop97f9b2beDb7446e4A4ebF650a665eb10" {...props} />}
      </div>
      {props["hero"] || <HomePageHeroC6924d2199f944699b974d728dcf0ba0 parentTag="HeroDe4f04390a974eeb8d383a6f549f1b8d" {...props} />}
    </div>
  );
}

// id: "fe7212a6-bc85-4fda-9c22-f04bff95ae97"
// title: ""
// type: :reference
// key: "footer"
// parent_id: "a72cc2ed-1a20-4fdb-a2a0-21d40931618d"
export function FooterFe7212a6Bc854fda9c22F04bff95ae97(props: any) {
  return (
    <DefaultFooterCd2d001090fb43149ac6246cf52fa408 parentTag="FooterFe7212a6Bc854fda9c22F04bff95ae97" {...props} />
  );
}

// id: "5a695c01-c2e3-412e-800e-71c30f983479"
// title: ""
// type: :reference
// key: "footer"
// parent_id: "da61957a-71ba-45ca-ac9b-42f666ed30f8"
export function Footer5a695c01C2e3412e800e71c30f983479(props: any) {
  return (
    <DefaultFooterCd2d001090fb43149ac6246cf52fa408 parentTag="Footer5a695c01C2e3412e800e71c30f983479" {...props} />
  );
}

// id: "d6b64d19-9bd8-481c-be7e-136ccccd6c70"
// title: ""
// type: :reference
// key: "header-top"
// parent_id: "745bba77-7271-4418-b348-f47372dfa03d"
export function HeaderTopD6b64d199bd8481cBe7e136ccccd6c70(props: any) {
  return (
    <DefaultHeaderTopC6395266Ab584052948f3e30603e1d38 parentTag="HeaderTopD6b64d199bd8481cBe7e136ccccd6c70" navMenuSlug="members-primary-nav" {...props} />
  );
}

// id: "034605d7-c160-4ffd-9a2e-67ce716d05cd"
// title: ""
// type: :text
// key: "navMenuSlug"
// parent_id: "8efb6987-2b0a-4201-b420-bdeaf69b69a4"
export const NavMenuSlug034605d7C1604ffd9a2e67ce716d05cd = "members-primary-nav";

// id: "c040cadf-4bac-463e-904e-6456d750f401"
// title: "Resources Page"
// type: :reference
// key: "resources-page"
// parent_id: nil
export function ResourcesPageC040cadf4bac463e904e6456d750f401(props: any) {
  return (
    <SecondaryPage819d7eedC2b545c78cb7364f2526597a parentTag="ResourcesPageC040cadf4bac463e904e6456d750f401" header={<SecondaryMarketingHeader7745eefb04164eb2B2a4134a9071d600 parentTag="HeaderD1c4cde082a2402dB1396c865309f0a6" title="Resources" />} {...props} />
  );
}

// id: "de4f0439-0a97-4eeb-8d38-3a6f549f1b8d"
// title: ""
// type: :reference
// key: "hero"
// parent_id: "65c78da3-057a-41a4-af11-5643aaedf7d1"
export function HeroDe4f04390a974eeb8d383a6f549f1b8d(props: any) {
  return (
    <HomePageHeroC6924d2199f944699b974d728dcf0ba0 parentTag="HeroDe4f04390a974eeb8d383a6f549f1b8d" {...props} />
  );
}

// id: "0dfcec10-4d35-470f-ad96-93b36e97e21f"
// title: ""
// type: :html
// key: "logo"
// parent_id: "cd2d0010-90fb-4314-9ac6-246cf52fa408"
export function Logo0dfcec104d35470fAd9693b36e97e21f(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <img src="https://mp1md-pub.s3.amazonaws.com/orgs/new-culture/logo-wide-white.svg" alt="logo" className={`${parentTag || ""} Logo0dfcec104d35470fAd9693b36e97e21f logo`} />
  );
}

// id: "a369f75c-c0dc-4d78-9c74-0d98873a1156"
// title: ""
// type: :reference
// key: "marketingCards"
// parent_id: "aa2a9e0b-ae76-4a6c-aebb-6b9c75fb86bf"
export function MarketingCardsA369f75cC0dc4d789c740d98873a1156(props: any) {
  return (
    <MarketingCards3d016643A9364700Ab2e1fc4fe5705b6 parentTag="MarketingCardsA369f75cC0dc4d789c740d98873a1156" postSlug="home-page-posts2" {...props} />
  );
}

// id: "6f9f4e36-f605-4372-ac1f-c5b3b1bd9fa4"
// title: ""
// type: :text
// key: "title"
// parent_id: "7297aef3-09e1-43d4-9f29-09dc3bbe54fc"
export const Title6f9f4e36F6054372Ac1fC5b3b1bd9fa4 = "About Us";

// id: "ce618a45-066f-4e8d-b10c-770a5f79bee6"
// title: "Logo"
// type: :html
// key: "default-logo"
// parent_id: nil
export function DefaultLogoCe618a45066f4e8dB10c770a5f79bee6(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <img src="https://mp1md-pub.s3-us-west-2.amazonaws.com/content/BTqIz3e7Nstwfg7w_file.svg" className={`${parentTag || ""} DefaultLogoCe618a45066f4e8dB10c770a5f79bee6 logo`} alt="logo" />
  );
}

// id: "467c8232-de2c-48f2-8006-0994f42f3c42"
// title: "Levels 1-4 Explained"
// type: :html
// key: "about-leveling-page"
// parent_id: nil
export function AboutLevelingPage467c8232De2c48f280060994f42f3c42(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} AboutLevelingPage467c8232De2c48f280060994f42f3c42`}>
      {props["header"] || <SecondaryMarketingHeader7745eefb04164eb2B2a4134a9071d600 parentTag="HeaderE9cd223094d145b18da8F3e74aa9add4" title="Leveling" {...props} />}
      {props.children}
      {props["footer"] || <DefaultFooterCd2d001090fb43149ac6246cf52fa408 parentTag="Footer3fa55dd001e84be383f6C4a4676d3ab5" {...props} />}
    </div>
  );
}

// id: "7a143ffd-65c4-436e-a21c-f216c6fe2a96"
// title: ""
// type: :text
// key: "postSlug"
// parent_id: "3d016643-a936-4700-ab2e-1fc4fe5705b6"
export const PostSlug7a143ffd65c4436eA21cF216c6fe2a96 = "home-page-posts2";

// id: "a4492fa3-1b63-476b-a4d7-0b5cb0141636"
// title: ""
// type: :reference
// key: "footer"
// parent_id: "47b6abe1-382f-4276-8143-37bdafa9443b"
export function FooterA4492fa31b63476bA4d70b5cb0141636(props: any) {
  return (
    <DefaultFooterCd2d001090fb43149ac6246cf52fa408 parentTag="FooterA4492fa31b63476bA4d70b5cb0141636" {...props} />
  );
}

// id: "f8999550-f674-49cf-a594-7067fd1ce180"
// title: ""
// type: :text
// key: "postSlug"
// parent_id: "71662219-38a1-4bbc-a547-f6f772f02e29"
export const PostSlugF8999550F67449cfA5947067fd1ce180 = "about-us-posts";

// id: "c8d2e91b-b9d6-4ac2-9fac-9ead5e7da9ed"
// title: ""
// type: :text
// key: "navMenuSlug"
// parent_id: "1ee582e0-06db-466c-a14b-30973305650a"
export const NavMenuSlugC8d2e91bB9d64ac29fac9ead5e7da9ed = "footer-nav";

// id: "cd2d0010-90fb-4314-9ac6-246cf52fa408"
// title: "Footer"
// type: :html
// key: "default-footer"
// parent_id: nil
export function DefaultFooterCd2d001090fb43149ac6246cf52fa408(props: any) {
  const Navigation = lookupPreset("Navigation");
  const GroupFlowTag = lookupPreset("GroupFlowTag");
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <footer className={`${parentTag || ""} DefaultFooterCd2d001090fb43149ac6246cf52fa408 footer`}>
      {props["links"] || <Navigation className="Links1ee582e006db466cA14b30973305650a" parentTag={buildClassName("Links1ee582e006db466cA14b30973305650a", parentTag)} navMenuSlug="footer-nav" {...props} />}
      <div className="logo-wrapper">
        {props["logo"] || <Logo0dfcec104d35470fAd9693b36e97e21f />}
      </div>
      <div>
        ©️ 2024 New Culture Camper Profile Directory
      </div>
      {props["groupflow"] || <GroupFlowTag className="GroupflowD281fe25471940f7Ba20146425f8a150" parentTag={buildClassName("GroupflowD281fe25471940f7Ba20146425f8a150", parentTag)} {...props} />}
    </footer>
  );
}

// id: "8efb6987-2b0a-4201-b420-bdeaf69b69a4"
// title: ""
// type: :gf_preset
// key: "navigation"
// parent_id: "4d80fcc2-2046-4800-abaa-2a95523b9a78"
export function Navigation8efb69872b0a4201B420Bdeaf69b69a4(props: any) {
  const PrimaryNavigation = lookupPreset("PrimaryNavigation");
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <PrimaryNavigation className="Navigation8efb69872b0a4201B420Bdeaf69b69a4" parentTag={buildClassName("Navigation8efb69872b0a4201B420Bdeaf69b69a4", parentTag)} navMenuSlug="members-primary-nav" {...props} />
  );
}

// id: "e36216dc-32ee-434e-9788-2c8b9d4b012e"
// title: ""
// type: :text
// key: "title"
// parent_id: "d9297d32-9895-4073-bf7e-0ec7dcf5b078"
export const TitleE36216dc32ee434e97882c8b9d4b012e = "Secondary Page";

// id: "ea7acbe8-4a2d-4059-b278-293eaa837ae5"
// title: "Admin Pages"
// type: :html
// key: "admin-pages"
// parent_id: nil
export function AdminPagesEa7acbe84a2d4059B278293eaa837ae5(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} AdminPagesEa7acbe84a2d4059B278293eaa837ae5`}>
      {props.children}
    </div>
  );
}

// id: "aa2a9e0b-ae76-4a6c-aebb-6b9c75fb86bf"
// title: "Marketing Cards Body"
// type: :html
// key: "marketing-body"
// parent_id: nil
export function MarketingBodyAa2a9e0bAe764a6cAebb6b9c75fb86bf(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} MarketingBodyAa2a9e0bAe764a6cAebb6b9c75fb86bf page-body`}>
      {props["marketingCards"] || <MarketingCards3d016643A9364700Ab2e1fc4fe5705b6 parentTag="MarketingCardsA369f75cC0dc4d789c740d98873a1156" postSlug="home-page-posts2" {...props} />}
    </div>
  );
}

// id: "1d2d6ab5-aa4b-41ec-8e84-46b6e27cce31"
// title: ""
// type: :text
// key: "alt"
// parent_id: "ce618a45-066f-4e8d-b10c-770a5f79bee6"
export const Alt1d2d6ab5Aa4b41ec8e8446b6e27cce31 = "logo";

// id: "7f698a7b-5271-4cc4-bf81-a37c2ef68de7"
// title: ""
// type: :reference
// key: "header"
// parent_id: "f76e6fc5-e86d-4e6a-97d9-f29eb9729c45"
export function Header7f698a7b52714cc4Bf81A37c2ef68de7(props: any) {
  return (
    <MembersAreaHeader745bba7772714418B348F47372dfa03d parentTag="Header7f698a7b52714cc4Bf81A37c2ef68de7" {...props} />
  );
}

// id: "73d352a3-0911-46f2-b38e-82ad4f769d7d"
// title: ""
// type: :text
// key: "class"
// parent_id: "2ff3c744-bcb9-4d10-81fc-701ecd590232"
export const Class73d352a3091146f2B38e82ad4f769d7d = "navigation";

// id: "329a825a-9056-4830-8c75-c79ab0de1fd2"
// title: ""
// type: :reference
// key: "label"
// parent_id: "5231ec57-fc5e-4b9f-be6b-7dc3d14ae51b"
export function Label329a825a905648308c75C79ab0de1fd2(props: any) {
  return (
    <DefaultLogoCe618a45066f4e8dB10c770a5f79bee6 parentTag="Label329a825a905648308c75C79ab0de1fd2" {...props} />
  );
}

// id: "e7e74206-707e-4d96-a237-a12c7738002c"
// title: "Label"
// type: :reference
// key: "label"
// parent_id: nil
export function LabelE7e74206707e4d96A237A12c7738002c(props: any) {
  return (
    <DefaultLogoCe618a45066f4e8dB10c770a5f79bee6 parentTag="LabelE7e74206707e4d96A237A12c7738002c" {...props} />
  );
}

// id: "e9cd2230-94d1-45b1-8da8-f3e74aa9add4"
// title: ""
// type: :reference
// key: "header"
// parent_id: "467c8232-de2c-48f2-8006-0994f42f3c42"
export function HeaderE9cd223094d145b18da8F3e74aa9add4(props: any) {
  return (
    <SecondaryMarketingHeader7745eefb04164eb2B2a4134a9071d600 parentTag="HeaderE9cd223094d145b18da8F3e74aa9add4" title="Leveling" {...props} />
  );
}

// id: "953b6bfb-d57d-458a-b8e5-735bc1c0a94b"
// title: ""
// type: :reference
// key: "footer"
// parent_id: "31886609-2f22-43fc-8c7b-0c05ebc0d508"
export function Footer953b6bfbD57d458aB8e5735bc1c0a94b(props: any) {
  return (
    <DefaultFooterCd2d001090fb43149ac6246cf52fa408 parentTag="Footer953b6bfbD57d458aB8e5735bc1c0a94b" {...props} />
  );
}

// id: "e5aa292c-9700-4660-9415-8ad4acd6d0c1"
// title: ""
// type: :text
// key: "title"
// parent_id: "385427a1-bd50-46e5-8646-a1458cc31643"
export const TitleE5aa292c9700466094158ad4acd6d0c1 = null;

// id: "3de8ddc0-087b-413b-8969-4c5e1df61b83"
// title: ""
// type: :text
// key: "title"
// parent_id: "4b39494b-a7c7-45e2-a021-6ef8f393ecf5"
export const Title3de8ddc0087b413b89694c5e1df61b83 = "Public Events";

// id: "f76e6fc5-e86d-4e6a-97d9-f29eb9729c45"
// title: "Message Pages"
// type: :html
// key: "message-pages"
// parent_id: nil
export function MessagePagesF76e6fc5E86d4e6a97d9F29eb9729c45(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} MessagePagesF76e6fc5E86d4e6a97d9F29eb9729c45`}>
      {props["header"] || <MembersAreaHeader745bba7772714418B348F47372dfa03d parentTag="Header7f698a7b52714cc4Bf81A37c2ef68de7" {...props} />}
      {props.children}
    </div>
  );
}

// id: "385427a1-bd50-46e5-8646-a1458cc31643"
// title: "Default Header Reference"
// type: :reference
// key: "default-header"
// parent_id: nil
export function DefaultHeader385427a1Bd5046e58646A1458cc31643(props: any) {
  return (
    <ShortHeader4d80fcc220464800Abaa2a95523b9a78 parentTag="DefaultHeader385427a1Bd5046e58646A1458cc31643" navMenuSlug="marketing-primary-nav" title {...props} />
  );
}

// id: "2ff60546-dac4-400f-b0d2-3ed8907b53ce"
// title: ""
// type: :gf_preset
// key: "button"
// parent_id: "c6924d21-99f9-4469-9b97-4d728dcf0ba0"
export function Button2ff60546Dac4400fB0d23ed8907b53ce(props: any) {
  const Button = lookupPreset("Button");
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Button className="Button2ff60546Dac4400fB0d23ed8907b53ce" parentTag={buildClassName("Button2ff60546Dac4400fB0d23ed8907b53ce", parentTag)} label="Join Us" href="/join" {...props} />
  );
}

// id: "30ea73e2-9815-4859-ae27-64179ef645e2"
// title: ""
// type: :text
// key: "title"
// parent_id: "5f9c91cd-93d0-45d9-ac59-ef8c7b564c33"
export const Title30ea73e298154859Ae2764179ef645e2 = "Default Title";

// id: "e2876cb0-ebe2-44c2-9244-5653cc5a4a3f"
// title: ""
// type: :text
// key: "navMenuSlug"
// parent_id: "df401107-78ea-4463-b619-63f921d2247f"
export const NavMenuSlugE2876cb0Ebe244c292445653cc5a4a3f = "members-primary-nav";

// id: "745bba77-7271-4418-b348-f47372dfa03d"
// title: "Members Area Header"
// type: :reference
// key: "members-area-header"
// parent_id: nil
export function MembersAreaHeader745bba7772714418B348F47372dfa03d(props: any) {
  return (
    <ShortHeader4d80fcc220464800Abaa2a95523b9a78 parentTag="MembersAreaHeader745bba7772714418B348F47372dfa03d" header-top={<DefaultHeaderTopC6395266Ab584052948f3e30603e1d38 parentTag="HeaderTopD6b64d199bd8481cBe7e136ccccd6c70" navMenuSlug="members-primary-nav" />} {...props} />
  );
}

// id: "5231ec57-fc5e-4b9f-be6b-7dc3d14ae51b"
// title: ""
// type: :gf_preset
// key: "linked-logo"
// parent_id: "c6395266-ab58-4052-948f-3e30603e1d38"
export function LinkedLogo5231ec57Fc5e4b9fBe6b7dc3d14ae51b(props: any) {
  const Link = lookupPreset("Link");
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Link className="LinkedLogo5231ec57Fc5e4b9fBe6b7dc3d14ae51b" parentTag={buildClassName("LinkedLogo5231ec57Fc5e4b9fBe6b7dc3d14ae51b", parentTag)} url="/" label={<DefaultLogoCe618a45066f4e8dB10c770a5f79bee6 parentTag="Label329a825a905648308c75C79ab0de1fd2" alt="logo" />} className="linked-logo" {...props} />
  );
}

// id: "0be972ad-05aa-46fe-9a73-d836038e6b4f"
// title: ""
// type: :reference
// key: "header"
// parent_id: "da61957a-71ba-45ca-ac9b-42f666ed30f8"
export function Header0be972ad05aa46fe9a73D836038e6b4f(props: any) {
  return (
    <HomeHeader65c78da3057a41a4Af115643aaedf7d1 parentTag="Header0be972ad05aa46fe9a73D836038e6b4f" {...props} />
  );
}

// id: "97f9b2be-db74-46e4-a4eb-f650a665eb10"
// title: ""
// type: :reference
// key: "header-top"
// parent_id: "65c78da3-057a-41a4-af11-5643aaedf7d1"
export function HeaderTop97f9b2beDb7446e4A4ebF650a665eb10(props: any) {
  return (
    <DefaultHeaderTopC6395266Ab584052948f3e30603e1d38 parentTag="HeaderTop97f9b2beDb7446e4A4ebF650a665eb10" {...props} />
  );
}

// id: "515e860c-a8b2-4898-817e-74b761cfb649"
// title: ""
// type: :text
// key: "class"
// parent_id: "5231ec57-fc5e-4b9f-be6b-7dc3d14ae51b"
export const Class515e860cA8b24898817e74b761cfb649 = "linked-logo";

// id: "3d016643-a936-4700-ab2e-1fc4fe5705b6"
// title: "Marketing Cards"
// type: :gf_preset
// key: "marketing-cards"
// parent_id: nil
export function MarketingCards3d016643A9364700Ab2e1fc4fe5705b6(props: any) {
  const MarketingCards = lookupPreset("MarketingCards");
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <MarketingCards className="MarketingCards3d016643A9364700Ab2e1fc4fe5705b6" parentTag={buildClassName("MarketingCards3d016643A9364700Ab2e1fc4fe5705b6", parentTag)} buttonClass="inline-block px-12 py-3 hover:brightness-110 transition duration" postSlug="home-page-posts2" {...props} />
  );
}

// id: "d281fe25-4719-40f7-ba20-146425f8a150"
// title: ""
// type: :gf_preset
// key: "groupflow"
// parent_id: "cd2d0010-90fb-4314-9ac6-246cf52fa408"
export function GroupflowD281fe25471940f7Ba20146425f8a150(props: any) {
  const GroupFlowTag = lookupPreset("GroupFlowTag");
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <GroupFlowTag className="GroupflowD281fe25471940f7Ba20146425f8a150" parentTag={buildClassName("GroupflowD281fe25471940f7Ba20146425f8a150", parentTag)} {...props} />
  );
}

// id: "4b39494b-a7c7-45e2-a021-6ef8f393ecf5"
// title: ""
// type: :reference
// key: "header"
// parent_id: "a72cc2ed-1a20-4fdb-a2a0-21d40931618d"
export function Header4b39494bA7c745e2A0216ef8f393ecf5(props: any) {
  return (
    <SecondaryMarketingHeader7745eefb04164eb2B2a4134a9071d600 parentTag="Header4b39494bA7c745e2A0216ef8f393ecf5" title="Public Events" {...props} />
  );
}

// id: "0d84881c-f666-43aa-94e4-5af855908fc7"
// title: ""
// type: :text
// key: "navMenuSlug"
// parent_id: "2ff3c744-bcb9-4d10-81fc-701ecd590232"
export const NavMenuSlug0d84881cF66643aa94e45af855908fc7 = "marketing-primary-nav";

// id: "8e87ba59-169a-48f9-99c2-6dfceb7fc692"
// title: "Title - Leveling"
// type: :text
// key: "title"
// parent_id: nil
export const Title8e87ba59169a48f999c26dfceb7fc692 = "Leveling";

// id: "bd34f78b-8dcb-4bd8-93ab-61c7f195e37e"
// title: ""
// type: :reference
// key: "header"
// parent_id: "31886609-2f22-43fc-8c7b-0c05ebc0d508"
export function HeaderBd34f78b8dcb4bd893ab61c7f195e37e(props: any) {
  return (
    <MembersAreaHeader745bba7772714418B348F47372dfa03d parentTag="HeaderBd34f78b8dcb4bd893ab61c7f195e37e" {...props} />
  );
}

// id: "9df776a9-bbb6-48e4-9695-8ffbce9fb772"
// title: ""
// type: :gf_preset
// key: "linked-logo"
// parent_id: "4d80fcc2-2046-4800-abaa-2a95523b9a78"
export function LinkedLogo9df776a9Bbb648e496958ffbce9fb772(props: any) {
  const Link = lookupPreset("Link");
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Link className="LinkedLogo9df776a9Bbb648e496958ffbce9fb772" parentTag={buildClassName("LinkedLogo9df776a9Bbb648e496958ffbce9fb772", parentTag)} label={<DefaultLogoCe618a45066f4e8dB10c770a5f79bee6 parentTag="Label322e09c0A4484ef3892e2c514ee97cd7" alt="logo" />} {...props} />
  );
}

// id: "35989f4b-7d82-49e4-b8f2-6be2a7ef729c"
// title: ""
// type: :reference
// key: "header-top"
// parent_id: "7745eefb-0416-4eb2-b2a4-134a9071d600"
export function HeaderTop35989f4b7d8249e4B8f26be2a7ef729c(props: any) {
  return (
    <DefaultHeaderTopC6395266Ab584052948f3e30603e1d38 parentTag="HeaderTop35989f4b7d8249e4B8f26be2a7ef729c" {...props} />
  );
}

// id: "e2b9e3a4-38db-4a90-9916-51072641f5a3"
// title: ""
// type: :text
// key: "navMenuSlug"
// parent_id: "d6b64d19-9bd8-481c-be7e-136ccccd6c70"
export const NavMenuSlugE2b9e3a438db4a90991651072641f5a3 = "members-primary-nav";

// id: "5f9c91cd-93d0-45d9-ac59-ef8c7b564c33"
// title: "Secondary Marketing Hero"
// type: :html
// key: "secondary-marketing-hero"
// parent_id: nil
export function SecondaryMarketingHero5f9c91cd93d045d9Ac59Ef8c7b564c33(props: any) {
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <div className={`${parentTag || ""} SecondaryMarketingHero5f9c91cd93d045d9Ac59Ef8c7b564c33 hero`}>
      <div className="title">
        {props["title"] || Title30ea73e298154859Ae2764179ef645e2}
      </div>
    </div>
  );
}

// id: "71662219-38a1-4bbc-a547-f6f772f02e29"
// title: ""
// type: :reference
// key: "body"
// parent_id: "89794182-97d7-4e9c-90a4-07ff3f8e5610"
export function Body7166221938a14bbcA547F6f772f02e29(props: any) {
  return (
    <MarketingBodyAa2a9e0bAe764a6cAebb6b9c75fb86bf parentTag="Body7166221938a14bbcA547F6f772f02e29" postSlug="about-us-posts" {...props} />
  );
}

// id: "1ee582e0-06db-466c-a14b-30973305650a"
// title: ""
// type: :gf_preset
// key: "links"
// parent_id: "cd2d0010-90fb-4314-9ac6-246cf52fa408"
export function Links1ee582e006db466cA14b30973305650a(props: any) {
  const Navigation = lookupPreset("Navigation");
  const { parentTag, ...rest } = props;
  props = rest;
  return (
    <Navigation className="Links1ee582e006db466cA14b30973305650a" parentTag={buildClassName("Links1ee582e006db466cA14b30973305650a", parentTag)} navMenuSlug="footer-nav" {...props} />
  );
}

// id: "322e09c0-a448-4ef3-892e-2c514ee97cd7"
// title: ""
// type: :reference
// key: "label"
// parent_id: "9df776a9-bbb6-48e4-9695-8ffbce9fb772"
export function Label322e09c0A4484ef3892e2c514ee97cd7(props: any) {
  return (
    <DefaultLogoCe618a45066f4e8dB10c770a5f79bee6 parentTag="Label322e09c0A4484ef3892e2c514ee97cd7" {...props} />
  );
}

const Components = {
  HomePageHeroC6924d2199f944699b974d728dcf0ba0,
  HrefC36c6ef7472f4b08Bad4D727591b5aed,
  ShortHeader4d80fcc220464800Abaa2a95523b9a78,
  NavMenuSlugA8e9dcdb3bd04fd7Bcf5Ba7d56b37e0b,
  HeaderDf40110778ea4463B61963f921d2247f,
  ContentSlugE7b400a319884badB73603bf353716f8,
  PublicEventsPageA72cc2ed1a204fdbA2a021d40931618d,
  Footer3fa55dd001e84be383f6C4a4676d3ab5,
  TitleCa3a7edd33784785A2c0A4333dbfcd82,
  FooterCae9eee62a8046c8A2d3C013315382be,
  Title42bfab54Fbae4f28936aA2619552c65c,
  Header3098910b4ed14707B4324d4ce5793157,
  ButtonClassFbdfe1ce19004c9bAbd94aa28a28a4a1,
  Header3616575353064408A37f8c659011e366,
  BackgroundImageDb947236825144a99c480ee4bc6bea1b,
  Label6024bc3b5cba41fbB25fEbf7ed943299,
  MembersAreaDefault47b6abe1382f4276814337bdafa9443b,
  SignupPages68f8eef435a549128d100258ae2dde19,
  WelcomeBack360eed49Bef84a97Ab8f5df36f0ba5ed,
  Href97dbec695fbf497d84f4Db252658fa2e,
  PostSlug83051fa707334a72A342E31d759feccd,
  DefaultHeaderTopC6395266Ab584052948f3e30603e1d38,
  JoinUsPageA26e9b1322ac4469B64f252069808545,
  BodyA8f063a91b1e45ecA1c6045e2e985946,
  Navigation2ff3c744Bcb94d1081fc701ecd590232,
  Url26eaf94eFf2e4ed89ad134af04c54ed8,
  Footer62a5ea3bA58d477cAf1c7f736286cc60,
  PageQuote85fc56c855784a669865E675e07d0430,
  TitleBfafcb49C1814294967fDf3d333cd11f,
  HeroA1d697e54fb646cfA5a196590abbc9d6,
  Title8ef9963aE8c149a98efdBc75d812a0a0,
  Title0f8a24996f494a379381B366f0ec53d2,
  SecondaryMarketingHeader7745eefb04164eb2B2a4134a9071d600,
  SecondaryPage819d7eedC2b545c78cb7364f2526597a,
  QuoteB74b7c7e56d8493eA011De5131c754cc,
  HeaderD1c4cde082a2402dB1396c865309f0a6,
  ContentSlugB5e05987143e41b38b73661726788c88,
  HomePageDa61957a71ba45caAc9b42f666ed30f8,
  MemberPages318866092f2243fc8c7b0c05ebc0d508,
  Header118372f185bf4089Bc76865e374ea742,
  Header7297aef309e143d49f2909dc3bbe54fc,
  Title2dced3b88cca4145B88f692c6d08acf5,
  AboutUsPage8979418297d74e9c90a407ff3f8e5610,
  HeaderD9297d3298954073Bf7e0ec7dcf5b078,
  CopyrightB8ecd9df4b5f4af4927a6076a5037683,
  Footer8a626229A8d944d5A969369688734755,
  TitleA87c79a27d744bc4B9f675f3b462e519,
  HomeHeader65c78da3057a41a4Af115643aaedf7d1,
  FooterFe7212a6Bc854fda9c22F04bff95ae97,
  Footer5a695c01C2e3412e800e71c30f983479,
  HeaderTopD6b64d199bd8481cBe7e136ccccd6c70,
  NavMenuSlug034605d7C1604ffd9a2e67ce716d05cd,
  ResourcesPageC040cadf4bac463e904e6456d750f401,
  HeroDe4f04390a974eeb8d383a6f549f1b8d,
  Logo0dfcec104d35470fAd9693b36e97e21f,
  MarketingCardsA369f75cC0dc4d789c740d98873a1156,
  Title6f9f4e36F6054372Ac1fC5b3b1bd9fa4,
  DefaultLogoCe618a45066f4e8dB10c770a5f79bee6,
  AboutLevelingPage467c8232De2c48f280060994f42f3c42,
  PostSlug7a143ffd65c4436eA21cF216c6fe2a96,
  FooterA4492fa31b63476bA4d70b5cb0141636,
  PostSlugF8999550F67449cfA5947067fd1ce180,
  NavMenuSlugC8d2e91bB9d64ac29fac9ead5e7da9ed,
  DefaultFooterCd2d001090fb43149ac6246cf52fa408,
  Navigation8efb69872b0a4201B420Bdeaf69b69a4,
  TitleE36216dc32ee434e97882c8b9d4b012e,
  AdminPagesEa7acbe84a2d4059B278293eaa837ae5,
  MarketingBodyAa2a9e0bAe764a6cAebb6b9c75fb86bf,
  Alt1d2d6ab5Aa4b41ec8e8446b6e27cce31,
  Header7f698a7b52714cc4Bf81A37c2ef68de7,
  Class73d352a3091146f2B38e82ad4f769d7d,
  Label329a825a905648308c75C79ab0de1fd2,
  LabelE7e74206707e4d96A237A12c7738002c,
  HeaderE9cd223094d145b18da8F3e74aa9add4,
  Footer953b6bfbD57d458aB8e5735bc1c0a94b,
  TitleE5aa292c9700466094158ad4acd6d0c1,
  Title3de8ddc0087b413b89694c5e1df61b83,
  MessagePagesF76e6fc5E86d4e6a97d9F29eb9729c45,
  DefaultHeader385427a1Bd5046e58646A1458cc31643,
  Button2ff60546Dac4400fB0d23ed8907b53ce,
  Title30ea73e298154859Ae2764179ef645e2,
  NavMenuSlugE2876cb0Ebe244c292445653cc5a4a3f,
  MembersAreaHeader745bba7772714418B348F47372dfa03d,
  LinkedLogo5231ec57Fc5e4b9fBe6b7dc3d14ae51b,
  Header0be972ad05aa46fe9a73D836038e6b4f,
  HeaderTop97f9b2beDb7446e4A4ebF650a665eb10,
  Class515e860cA8b24898817e74b761cfb649,
  MarketingCards3d016643A9364700Ab2e1fc4fe5705b6,
  GroupflowD281fe25471940f7Ba20146425f8a150,
  Header4b39494bA7c745e2A0216ef8f393ecf5,
  NavMenuSlug0d84881cF66643aa94e45af855908fc7,
  Title8e87ba59169a48f999c26dfceb7fc692,
  HeaderBd34f78b8dcb4bd893ab61c7f195e37e,
  LinkedLogo9df776a9Bbb648e496958ffbce9fb772,
  HeaderTop35989f4b7d8249e4B8f26be2a7ef729c,
  NavMenuSlugE2b9e3a438db4a90991651072641f5a3,
  SecondaryMarketingHero5f9c91cd93d045d9Ac59Ef8c7b564c33,
  Body7166221938a14bbcA547F6f772f02e29,
  Links1ee582e006db466cA14b30973305650a,
  Label322e09c0A4484ef3892e2c514ee97cd7
}

export default Components;